/**
 * Clamps a number to the inclusive [min, max] range.
 * If `min` is greater than `max`, the bounds are swapped.
 *
 * @param value - The number to clamp.
 * @param min - The lower bound of the range.
 * @param max - The upper bound of the range.
 * @returns The clamped value, guaranteed to be between `min` and `max` (inclusive).
 */
export function clamp(value: number, min: number, max: number) {
  const lowerBound = Math.min(min, max);
  const upperBound = Math.max(min, max);

  return Math.min(Math.max(value, lowerBound), upperBound);
}
